import { render, staticRenderFns } from "./puntos-suministros-formulario.vue?vue&type=template&id=1af52ff6&"
import script from "./puntos-suministros-formulario.vue?vue&type=script&lang=js&"
export * from "./puntos-suministros-formulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports